module.exports = __webpack_public_path__ + "img/kaqian.80f82f90.png";